module.exports = __webpack_public_path__ + "img/DSSSS.a50ef0a3.svg";